module.exports = __webpack_public_path__ + "img/n2.1a904beb.png";